import React, {Component} from 'react';
import {Col, Grid, Row} from 'react-bootstrap';
import {connect} from 'react-redux';
import {actions} from 'react-redux-form';
import BackLink from '../../../../common/back-link/index';
import PageTitle from '../../../../common/page-title/index';
import PushNotificationForm from './push-notification-form';
import PushNotificationsTemplateTable from './push-notifications-table';
import {
  deletePushNotificationTemplate,
  getPushNotificationTemplate,
  getPushNotificationTemplates,
  savePushNotification,
  savePushNotificationTemplate
} from '../../../../../actions/pushNotifications';
import {getGroups} from '../../../../../actions/home';
import ConfirmPopup from '../../../../common/confirm-popup';
import {pushNotificationTemplate as initialState} from '../../../../../initialStates';
import pages from '../../../../../data/mobileAppPages';

const TEMPLATE_MODEL = 'deep.push_notification_template';

class PushNotificationTemplatesPage extends Component {
  state = {
    toDelete: undefined,
  };

  componentWillMount() {
    const {dispatch} = this.props;
    dispatch(getPushNotificationTemplates());
    dispatch(getGroups());
  }

  onEdit = (id) => {
    this.loadTemplate(id);
  };

  loadTemplate = id => this.props.dispatch(getPushNotificationTemplate(id))
    .then(() => {
      const {content, title, page} = this.props.notificationTemplate.attributes;
      const { groups } = this.props;
      this.props.dispatch(actions.load(TEMPLATE_MODEL, {
        ...initialState,
        content,
        title,
        page,
        group_ids: this.props.notificationTemplate.attributes['group-ids'].map(groupId =>
          groups.find(g => g.id === groupId)).filter(Boolean).map(g => ({ label: g.name, value: g.id }))
      }));
    });

  onDelete = (id) => {
    this.setState({toDelete: id});
  };

  confirmDelete = () => {
    const {dispatch} = this.props;
    dispatch(deletePushNotificationTemplate(this.state.toDelete));
    this.setState({toDelete: undefined});
  };

  onPush = (id) => {
    this.loadTemplate(id).then(() => {
      this.onPushSave();
    });
  };

  resetForm = () => {
    const {dispatch, formData} = this.props;
    Object.keys(formData).forEach((model) => {
      if (model === 'group_ids' || model === 'group-ids') {
        dispatch(actions.change(`${TEMPLATE_MODEL}.group_ids`, []));
      } else {
        dispatch(actions.change(`${TEMPLATE_MODEL}.${model}`, ''));
      }
    });
  };

  onPushSave = () => {
    const {dispatch, formData} = this.props;
    dispatch(savePushNotification(formData, this.resetForm));
  };

  onTemplateSave = () => {
    const {dispatch, formData} = this.props;
    dispatch(savePushNotificationTemplate(formData, this.resetForm));
  };

  render() {
    const {
      onEdit, onDelete, onPush, onPushSave, onTemplateSave, confirmDelete
    } = this;
    const {
      notificationTemplates, invalid, formData, groups
    } = this.props;
    const {toDelete} = this.state;

    return (
      <Grid>
        <Row>
          <Col lg={12}>
            <BackLink href="/"/>
            <PageTitle>Push notifications</PageTitle>
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <h2>Templates</h2>
            <PushNotificationsTemplateTable
              notifications={notificationTemplates}
              onEdit={onEdit}
              onDelete={onDelete}
              onPush={onPush}
            />
          </Col>
        </Row>
        <Row>
          <Col lg={12}>
            <PushNotificationForm
              model={TEMPLATE_MODEL}
              onPushSave={onPushSave}
              onTemplateSave={onTemplateSave}
              invalid={invalid}
              pages={pages}
              formData={formData}
              groups={groups}
            />
          </Col>
        </Row>

        {toDelete && (
          <ConfirmPopup
            header="DELETE TEMPLATE?"
            onClose={confirmDelete}
          >
            <p>
              Are you sure you want to delete this template?
            </p>
          </ConfirmPopup>
        )}
      </Grid>
    );
  }
}

const mapStateToProps = state => ({
  notificationTemplates: state.pushNotifications.notification_templates,
  notificationTemplate: state.pushNotifications.notification_template,
  formData: state.deep.push_notification_template,
  invalid: !state.deep.forms.push_notification_template.$form.valid,
  groups: state.groupSelector.groups || []
});

export default connect(mapStateToProps)(PushNotificationTemplatesPage);



// WEBPACK FOOTER //
// ./src/components/admin/app/push-notifications/templates/push-notification-templates-page.jsx